"use client";
import React, { useState } from "react";

import Multimedia from "@stadium/ui/src/components/multimedia/multimedia";

import textResolver from "@sendmagic/prismic-nextjs/src/constants/text-resolver";

import { checkContentPresence } from "@sendmagic/prismic-nextjs/src/helpers/prismic";

const EmbededLinkTag = ({
  embededObj: { embed_url = "" },
  urlText,
  convertLabelToModular = false,
  className = "",
}) => {
  const [openMediaModal, setOpenMediaModal] = useState(false);

  const closeModal = () => {
    setOpenMediaModal(false);
  };

  const openModal = () => {
    setOpenMediaModal(true);
  };
  return checkContentPresence(urlText) ? (
    <div className="video-slice-section">
      {embed_url && openMediaModal && (
        <div className="vimeo-video-popover">
          <div className="embed-responsive embed-responsive-16by9 vimeo-video-sub-container">
            <div className="close-icon-main" onClick={closeModal}>
              <a className="icon icon-close-filled close-icon icon-close" />
            </div>
            <Multimedia
              type="iframe"
              src={embed_url}
              className="embed-responsive-item"
              allow="autoplay"
              isNextImage={false}
            />
          </div>
        </div>
      )}
      <a onClick={openModal} className={className}>
        {textResolver(urlText, { convertLabelToModular })}
      </a>
    </div>
  ) : (
    ""
  );
};

export default EmbededLinkTag;
